import { contextFactory } from '@frontend/design-system';
import { UseFormsLocationsResults } from './useFormsLocations';

export const [DigitalFormsLocationsContext, useDigitalFormsLocationsContext] = contextFactory<UseFormsLocationsResults>(
  'useDigitalFormsLocationsContext must be used within a DigitalFormsLocationsContext'
);
